import { recurrenceEndpoint } from '../microsservices/CommerceApi';

export function requestAction(contractId: string, actionType: string, token: string): Promise<any> {
  return recurrenceEndpoint.post({ token }, {
    uriParams: {
      contractId,
      actionType,
    },
  });
}